import { render, staticRenderFns } from "./CompanyGroupList.vue?vue&type=template&id=768dd354&scoped=true&"
import script from "./CompanyGroupList.vue?vue&type=script&lang=ts&"
export * from "./CompanyGroupList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768dd354",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
